<template>
  <component
    :is="component"
    :dentate="dentate"
    @switch="handleSwitch"
    @next="$emit('next')"
    @step="(step) => $emit('step', step, this.dentate)"
  />
</template>

<script>
import { mapGetters } from "vuex"
import PostAlignment from "./ScanAnalysis/PostAlignment.vue"
import PreAlignment from "./ScanAnalysis/PreAlignment.vue"
export default {
  name: "ScanAnalysis",
  components: {
    PreAlignment,
    PostAlignment
  },
  props: ["prop"],
  data() {
    return {
      component: PreAlignment
    }
  },
  computed: {
    ...mapGetters(["validatedScansResponse", "orderDetails"]),
    dentate() {
      return this.prop || this.orderDetails.dentate
    }
  },
  methods: {
    handleSwitch() {
      this.component =
        this.component === PreAlignment ? PostAlignment : PreAlignment
    }
  },
  beforeCreate() {
    if (this.validatedScansResponse) this.component = PostAlignment
  }
}
</script>
